import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../../component/header";
import Footer from "../../component/footer";

const Blog = () => {
  const [allBlogData, setAllBlogData] = useState([]);
  const [filteredBlogData, setFilteredBlogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('0');
  const [visibleArticles, setVisibleArticles] = useState(6);
  const base_Url = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const categories = [
    { id: '0', name: 'All' },
    { id: '1', name: 'Finance' },
    { id: '2', name: 'Eco Friendly' },
    { id: '3', name: 'Non-profits' },
    { id: '4', name: 'Real estate' },
    { id: '5', name: 'Technology' }
  ];

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${base_Url}/Blog?start=0&pageSize=100`);
        if (!response.ok) {
          throw new Error(`Failed to load blogs (${response.status})`);
        }
        const data = await response.json();
        
        if (data.status?.code === 1 || data.Status?.Code === 1) {
          const blogData = data.data?.[0] || data.Data?.[0] || data.data || data.Data || [];
          const flattenedData = Array.isArray(blogData) ? blogData : [blogData];
          setAllBlogData(flattenedData);
          setFilteredBlogData(flattenedData);
        } else if (Array.isArray(data)) {
          setAllBlogData(data);
          setFilteredBlogData(data);
        } else {
          throw new Error(data.status?.message || data.Status?.Message || 'Unknown error');
        }
      } catch (err) {
        console.error('Blog fetch error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogData();
  }, [base_Url]);

  useEffect(() => {
    if (selectedCategory === '0') {
      setFilteredBlogData(allBlogData);
    } else {
      const filtered = allBlogData.filter(post => post.blogCategoryId === selectedCategory);
      setFilteredBlogData(filtered);
    }
    setVisibleArticles(6);
  }, [selectedCategory, allBlogData]);

  const loadMore = () => {
    setVisibleArticles(prevVisibleArticles => prevVisibleArticles + 6);
  };

  const handleCategoryChange = (categoryId) => {
    setSelectedCategory(categoryId);
  };

  const handlePostClick = (postId) => {
    navigate(`/Blog/${postId}`);
  };

  if (loading) {
    return (
      <div className="App">
        <Header />
        <div className="container text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <Header />
        <div className="container text-center py-5">
          <div className="alert alert-danger" role="alert">
            Error loading blog posts: {error}
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <div className="container">
        <div className="row mt-3 mb-3">
          <div className="top-tabs d-flex flex-direction-column">
            <ul className="nav nav-pills mb-0 nfaq-tab" id="pills-tab2" role="tablist">
              {categories.map((category) => (
                <li className="nav-item nfaq-tab-item" key={category.id} role="presentation">
                  <button
                    className={`nav-link nfaq-tab-item-btn ${selectedCategory === category.id ? 'active' : ''}`}
                    onClick={() => handleCategoryChange(category.id)}
                  >
                    {category.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      
      <div className="container mb-3">
        <div className="d-flex flex-wrap post-section justify-content-center">
          {filteredBlogData.length > 0 ? (
            filteredBlogData.slice(0, visibleArticles).map((article) => (
              <div 
                className="col-lg-3 col-sm-12 rounded-4 shadow-lg mb-4 post-card" 
                key={article.id}
                onClick={() => handlePostClick(article.id)}
              >
                <img 
                  className='rounded-top-4 w-100 post-image' 
                  src={article.imageUrl || "assets/icons-2/post one.png"} 
                  alt={article.title}
                />
                <div className="post-detail p-4">
                  <h3 className="post-title">{article.title}</h3>
                  <p className="post-description">{article.description}</p>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <p>No posts found in this category</p>
            </div>
          )}
          
          {filteredBlogData.length > visibleArticles && (
            <div className="d-flex justify-content-center mt-3 w-100">
              <button onClick={loadMore} className="btn btn-primary post-btn">Load More</button>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;